module.exports = __webpack_public_path__ + "img/symbol_7.a748ec58.png";